/*
 * TTTech nerve-management-system-frontend
 * Copyright(c) 2026 TTTech Industrial Automation AG.
 *
 * ALL RIGHTS RESERVED.
 * Usage of this software, including source code, netlists, documentation,
 * is subject to restrictions and conditions of the applicable license
 * agreement with TTTech Industrial Automation AG or its affiliates.
 *
 * All trademarks used are the property of their respective owners.
 * TTTech Industrial Automation AG and its affiliates do not assume any liability
 * arising out of the application or use of any product described or shown
 * herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 * make changes, at any time, in order to improve reliability, function or
 * design.
 *
 * Contact Information:
 * support@tttech-industrial.com
 * TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 */
import { defineStore } from 'pinia';

const defaultToastParams = {
  text: '',
  showClose: true,
  color: '',
};
const defaultMessageBoxParams = {
  title: '',
  text: '',
  list: [],
  noClose: false,
  redirect: false,
};

const useUtilsStore = defineStore('utils', {
  state: () => ({
    loadingBar: false,
    toast: false,
    toastParams: { ...defaultToastParams },
    messageBox: false,
    messageBoxParams: { ...defaultMessageBoxParams },
    confirmDialog: false,
    noConnectionStatus: false,
    confirmDialogParams: {
      title: '',
      subTitle: '',
      dontAskMeAgain: false,
      callback: null,
      cancelCallback: null,
      dontAskMeAgainCallback: null,
      isCheckboxVisible: false,
      isChecked: false,
    },
    progressBarDialog: false,
    progressBarDialogParams: {
      callback: null,
    },
    deployInfoDialog: false,
    deployInfoDialogParams: {
      title: '',
      titleParams: {},
      subTitle: '',
      callback: null,
    },
    apiPermissionConfirmDialog: false,
    apiPermissionConfirmDialogParams: {
      title: '',
      msg: '',
      confirmCallback: null,
      cancelCallback: null,
    },
    applyWorkloadConfigurationDialog: false,
    applyWorkloadConfigurationDialogParams: {
      title: '',
    },
    notificationDialog: false,
    notificationDialogParams: {
      title: '',
      subTitle: '',
      callback: null,
      cancelCallback: null,
    },
    loaderCircular: false,
  }),

  actions: {
    // --- Toast Actions ---
    showCustomToast(params) {
      if (this.toast) clearTimeout(this.toast);

      this.toastParams = { ...defaultToastParams, ...params };
      this.toast = setTimeout(() => {
        this.toast = !!params.permanent || false;
      }, 10000);
    },
    showPermanentToast(flag) {
      const params = {
        text: 'errorMessages.no_connection_error',
        color: 'red',
        showClose: true,
      };
      if (this.toast) clearTimeout(this.toast);
      this.toastParams = { ...defaultToastParams, ...params };
      this.toast = flag;
    },

    closeToast() {
      if (this.toast) clearTimeout(this.toast);
      this.toast = false;
    },
    // --- Message Box Actions ---
    showMessageBox(params) {
      this.messageBoxParams = { ...defaultMessageBoxParams, ...params };
      this.messageBox = true;
    },

    closeMessageBox() {
      this.messageBox = false;
      // TODO what was this call and do we need similar logic
      // if (this.messageBoxParams.redirect) store.dispatch('network-interface/redirect');
      this.messageBoxParams = { ...defaultMessageBoxParams };
    },
    // --- Loading & UI States ---
    showLoadingBar() {
      this.loadingBar = true;
    },

    closeLoadingBar() {
      this.loadingBar = false;
    },

    showLoaderCircular() {
      this.loaderCircular = true;
    },

    closeLoaderCircular() {
      this.loaderCircular = false;
    },

    changeNoConnectionStatus(flag) {
      this.noConnectionStatus = flag;
    },

    // --- Dialog Actions ---
    showConfirmDialog(params) {
      this.confirmDialog = true;
      this.confirmDialogParams = params;
    },

    closeConfirmDialog() {
      this.confirmDialog = false;
    },

    showProgressBarDialog(params) {
      this.progressBarDialog = true;
      this.progressBarDialogParams = params;
    },

    closeProgressBarDialog() {
      this.progressBarDialog = false;
    },

    showDeployInfoDialog(params) {
      this.deployInfoDialog = true;
      this.deployInfoDialogParams = params;
    },

    closeDeployInfo() {
      this.deployInfoDialog = false;
    },

    showApiPermissionConfirmDialog(params) {
      this.apiPermissionConfirmDialog = true;
      this.apiPermissionConfirmDialogParams = params;
    },

    closeApiPermissionConfirm() {
      this.apiPermissionConfirmDialog = false;
    },

    showNotificationDialog(params) {
      this.notificationDialog = true;
      this.notificationDialogParams = params;
    },

    closeNotificationDialog() {
      this.notificationDialog = false;
    },

    showApplyWorkloadConfigurationDialog(params) {
      this.applyWorkloadConfigurationDialog = true;
      this.applyWorkloadConfigurationDialogParams = params;
    },

    closeApplyWorkloadConfiguration() {
      this.applyWorkloadConfigurationDialog = false;
    },
  },
});

export default useUtilsStore;
